/**
 * @generated SignedSource<<3387037a79ad9527c7618756173221b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderServiceRow_orderService$data = {
  readonly amount: number;
  readonly itemPrice: number;
  readonly name: string;
  readonly price: number;
  readonly " $fragmentType": "OrderServiceRow_orderService";
};
export type OrderServiceRow_orderService$key = {
  readonly " $data"?: OrderServiceRow_orderService$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderServiceRow_orderService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderServiceRow_orderService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "itemPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    }
  ],
  "type": "OrderItem",
  "abstractKey": null
};

(node as any).hash = "572683c9d499625373f0d9aae43677fa";

export default node;
